import type { ComponentProps } from 'react';

import { ButtonLink } from '@change-corgi/design-system/components/actions';
import { Image } from '@change-corgi/design-system/components/media';
import { Flex } from '@change-corgi/design-system/layout';

import { usePromoteOrShareActions } from './hooks/usePromoteOrShareActions';

export function PromoteOrShareActions(props: ComponentProps<typeof Flex>) {
	const {
		data: { promoteButtonLabel, shareButtonLabel, promoteButtonUrl, shareButtonUrl, paymentIconsLabel },
		actions: { handlePromoteClick, handleShareClick },
	} = usePromoteOrShareActions();

	return (
		<Flex sx={{ flexDirection: 'column', alignItems: 'center' }} {...props}>
			<ButtonLink
				to={promoteButtonUrl}
				onClick={handlePromoteClick}
				sx={{ width: ['100%', 300] }}
				data-qa="promote-button"
			>
				{promoteButtonLabel}
			</ButtonLink>
			<ButtonLink
				variant="secondaryEmphasis"
				to={shareButtonUrl}
				onClick={handleShareClick}
				sx={{ width: ['100%', 300] }}
				mt={8}
				data-qa="share-button"
			>
				{shareButtonLabel}
			</ButtonLink>
			<Flex sx={{ flexDirection: 'column', alignItems: 'center', pt: 26 }}>
				<Image
					data-qa="payment-methods"
					alt={paymentIconsLabel}
					sx={{ width: ['80%', 260] }}
					src="https://static.change.org/psf/payment-method-icons.png"
				/>
			</Flex>
		</Flex>
	);
}
